import { WidgetModel } from './widget.model';
import { isDefined } from '@fi-shared/utils/is-defined';
import { WidgetPlaceHolderControlModel } from '@fi-shared/widget/widget-place-holder-control.model';

export class DocumentListingWidgetModel extends WidgetModel {
    onControlInitialized(control: WidgetPlaceHolderControlModel) {
        super.onControlInitialized(control);
        if (!isDefined(control.Settings.Pages)) {
            control.Settings.Pages = true;
        }
        if (!isDefined(control.Settings.Files)) {
            control.Settings.Files = true;
        }
        if (!isDefined(control.Settings.UseWidgetTagOptionType)) {
            control.Settings.UseWidgetTagOptionType = true;
        }

        if (!isDefined(control.Settings.NumberOfRecordsToTake)) {
            control.Settings.NumberOfRecordsToTake = 20;
        }
    }
}
